"use client"

import { Toilet } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ToiletIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ToiletIcon = component(Icon)({ as: Toilet })
